export default "__VITE_ASSET__D_x8r2Mz__"